export default __webpack_public_path__ + "static/media/Icon.b17638d0.svg";